import superAdmin from "./user"

export const superAdminReducers = {
  superAdmin: superAdmin.reducer
}
